/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateScheduledBreakData } from './CreateScheduledBreakData';
import {
    CreateScheduledBreakDataFromJSON,
    CreateScheduledBreakDataFromJSONTyped,
    CreateScheduledBreakDataToJSON,
    CreateScheduledBreakDataToJSONTyped,
} from './CreateScheduledBreakData';
import type { CreateShiftAreaSessionData } from './CreateShiftAreaSessionData';
import {
    CreateShiftAreaSessionDataFromJSON,
    CreateShiftAreaSessionDataFromJSONTyped,
    CreateShiftAreaSessionDataToJSON,
    CreateShiftAreaSessionDataToJSONTyped,
} from './CreateShiftAreaSessionData';

/**
 * 
 * @export
 * @interface CreateShiftData
 */
export interface CreateShiftData {
    /**
     * 
     * @type {number}
     * @memberof CreateShiftData
     */
    scheduleId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftData
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftData
     */
    employeeId: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftData
     */
    jobRoleId: number;
    /**
     * Whether to offer the shift to all eligible employees
     * @type {boolean}
     * @memberof CreateShiftData
     */
    open?: boolean;
    /**
     * Whether the system can auto-assign employees when they respond to an open shift
     * @type {boolean}
     * @memberof CreateShiftData
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateShiftData
     */
    startsAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateShiftData
     */
    endsAt: Date;
    /**
     * Whether to show the shift end time to non-managerial staff
     * @type {boolean}
     * @memberof CreateShiftData
     */
    showEndTime?: boolean;
    /**
     * Whether to show the job role to non-managerial staff
     * @type {boolean}
     * @memberof CreateShiftData
     */
    showJobRole?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShiftData
     */
    published?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftData
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<CreateScheduledBreakData>}
     * @memberof CreateShiftData
     */
    scheduledBreaks?: Array<CreateScheduledBreakData>;
    /**
     * 
     * @type {Array<CreateShiftAreaSessionData>}
     * @memberof CreateShiftData
     */
    shiftAreaSessions?: Array<CreateShiftAreaSessionData>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateShiftData
     */
    tags?: Array<number> | null;
}

/**
 * Check if a given object implements the CreateShiftData interface.
 */
export function instanceOfCreateShiftData(value: object): value is CreateShiftData {
    if (!('scheduleId' in value) || value['scheduleId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('startsAt' in value) || value['startsAt'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    return true;
}

export function CreateShiftDataFromJSON(json: any): CreateShiftData {
    return CreateShiftDataFromJSONTyped(json, false);
}

export function CreateShiftDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateShiftData {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduleId': json['scheduleId'],
        'locationId': json['locationId'],
        'employeeId': json['employeeId'],
        'jobRoleId': json['jobRoleId'],
        'open': json['open'] == null ? undefined : json['open'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'startsAt': (new Date(json['startsAt'])),
        'endsAt': (new Date(json['endsAt'])),
        'showEndTime': json['showEndTime'] == null ? undefined : json['showEndTime'],
        'showJobRole': json['showJobRole'] == null ? undefined : json['showJobRole'],
        'published': json['published'] == null ? undefined : json['published'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'scheduledBreaks': json['scheduledBreaks'] == null ? undefined : ((json['scheduledBreaks'] as Array<any>).map(CreateScheduledBreakDataFromJSON)),
        'shiftAreaSessions': json['shiftAreaSessions'] == null ? undefined : ((json['shiftAreaSessions'] as Array<any>).map(CreateShiftAreaSessionDataFromJSON)),
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

  export function CreateShiftDataToJSON(json: any): CreateShiftData {
      return CreateShiftDataToJSONTyped(json, false);
  }

  export function CreateShiftDataToJSONTyped(value?: CreateShiftData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduleId': value['scheduleId'],
        'locationId': value['locationId'],
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'open': value['open'],
        'requiresApproval': value['requiresApproval'],
        'startsAt': ((value['startsAt']).toISOString()),
        'endsAt': ((value['endsAt']).toISOString()),
        'showEndTime': value['showEndTime'],
        'showJobRole': value['showJobRole'],
        'published': value['published'],
        'notes': value['notes'],
        'scheduledBreaks': value['scheduledBreaks'] == null ? undefined : ((value['scheduledBreaks'] as Array<any>).map(CreateScheduledBreakDataToJSON)),
        'shiftAreaSessions': value['shiftAreaSessions'] == null ? undefined : ((value['shiftAreaSessions'] as Array<any>).map(CreateShiftAreaSessionDataToJSON)),
        'tags': value['tags'],
    };
}

